export const NR_COLS = 100
